/* eslint-disable import/no-unresolved */
/* eslint-disable global-require */
const path = require('path')
const fs = require('fs')

const basePath = process.cwd()
let projectName = require(path.join(basePath, 'package.json')).name
projectName = projectName.startsWith('@') ? projectName.split('qaw-')[1] : projectName

const prodConfigFolder = path.join(basePath, '..', 'config')
const defaultCertificateSubPath = 'certificates'

// Used for overriding the current service config, or parse external config
const parseArgv = () => {
  const resArgs = {}
  const args = process.argv.slice(2)
  if (args.includes('--config-path')) {
    resArgs.config = args[args.indexOf('--config-path') + 1]
    return resArgs
  }
  if (args.includes('--https')) {
    resArgs.https = true
  }
  if (args.includes('--port')) {
    resArgs.port = args[args.indexOf('--port') + 1]
  }
  return resArgs
}
const getCerts = args => {
  try {
    const certificatesPath =
      args && args.config
        ? `${args.config}/${defaultCertificateSubPath}`
        : `${
            fs.existsSync(prodConfigFolder)
              ? prodConfigFolder
              : `${basePath}/config`
          }${path.sep + defaultCertificateSubPath}`
    let ca
    try {
      ca = [fs.readFileSync(`${certificatesPath + path.sep}ca.crt`)]
    } catch (e) {
      console.log('Missing CA')
    }
    return {
      server_key: fs.readFileSync(
        `${certificatesPath + path.sep}server_key.pem`
      ),
      server: fs.readFileSync(`${certificatesPath + path.sep}server.pem`),
      ca
    }
  } catch (error) {
    throw Error(error)
  }
}
const parseConfigFile = (filePath, args) => {
  try {
    let cfg = require(filePath)
    const internalCfg = require(path.join(basePath, 'config/default.json'))[
      projectName
    ]
    if (internalCfg.uses) {
      cfg = { ...internalCfg.uses, ...cfg }
    }
    Object.keys(cfg[projectName]).forEach(key => {
      cfg[projectName][key] = args[key] || cfg[projectName][key]
    })
    if (cfg[projectName].https) {
      cfg[projectName].certs = getCerts(args)
    }
    return cfg
  } catch (error) {
    throw Error(error)
  }
}
function initConfig() {
  const args = parseArgv()
  const configFile =
    args.config ||
    `${
      fs.existsSync(prodConfigFolder) ? prodConfigFolder : `${basePath}/config`
    }`
  Object.assign(
    this,
    parseConfigFile(`${configFile + path.sep}default.json`, args)
  )
}

module.exports = {
  init: initConfig,
}
